
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useToastHandler } from "../../../../common/ToastHandler";
import "./Invoice.css";
import { useLocation } from "react-router-dom";
import TableComponent from "./InvoiceTable";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import AddVendorModal from "../../ReusableForm/AddVendorModal";
import CustomDateInput from "../../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../../context/useFormattingUtils";
function AddInvoice({requiredPerm }) {
  const { Post, Get } = useApi();
  let { user } = useContext(AuthContext);
  const today = new Date().toISOString().split("T")[0];
  const [reloadData, setReloadData] = useState(false);
  const dropdownRef = useRef(null);
  const { handleToast } = useToastHandler();
  const [showModal, setShowModal] = useState(false);
  const { formatDate } = useFormattingUtils();
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const { permissions } = useContext(AuthContext);
  const [activeButton, setActiveButton] = useState("");
 const hasAccess = permissions.includes("all") || permissions.includes(requiredPerm);
  const location = useLocation();

  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });
  };

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    date: today,
    vendor_department: "",
    vendor_department_name: "",
    invoice_no: "",
    pay_method_status: "pay_now",
    prepaid_tax: false,
    prepaid_tax_percentage: "",
    amount: "",
    remaining_amount: "",
    pay_method: "cash",
    due_date: null,
    note: "",
    bank: "",
    status: "",
    cheque_no: null,
    type: "",
  });

  const makeBlank = () => {
    setFormData({
      date: today,
      vendor_department: "",
      vendor_department_name: "",
      invoice_no: "",
      pay_method_status: "pay_now",
      prepaid_tax: false,
      prepaid_tax_percentage: "",
      amount: "",
      remaining_amount: "",
      pay_method: "cash",
      due_date: null,
      note: "",
      bank: "",
      status: "",
      cheque_no: null,
      type: "",
    });
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      remaining_amount: prevData.amount,
    }));
  }, [formData.amount]);

  const [vendors, setVendors] = useState([]);
  const [banks, setBanks] = useState([]);
  const [dueDays, setDueDays] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.vendor_department) {
      handleToast({
        type:"ERROR",
        message:"Please select a vendor before submitting."
      })
      return;
    }

    if (!formData.invoice_no) {
       handleToast({
        type:"ERROR",
        message:"Invoice number is required."
      })
      return;
    }

    if (!formData.amount) {
       handleToast({
        type:"ERROR",
        message:"Amount is required."
      })
      return;
    }

    if (!formData.pay_method) {
       handleToast({
        type:"ERROR",
        message:"Please select a payment method before submitting."
      })
      return;
    }

    const invoiceStatus =
      formData.pay_method_status === "pay_now" &&
      (formData.pay_method === "cash" ||
        formData.pay_method === "bank" ||
        formData.pay_method === "cheque")
        ? "paid"
        : "unpaid";

    const remainingAmount =
      invoiceStatus === "paid" ? 0 : formData.amount || "";

    const invoiceDataToSubmit = {
      ...formData,
      store: user.store,
      status: invoiceStatus,
      remaining_amount: remainingAmount,
      ...(formData.pay_method === "cash" && {
        payment_details: {
          bank: formData.bank,
          cheque: formData.cheque_no,
        },
      }),
      ...(formData.pay_method === "bank" && {
        payment_details: {
          bank: formData.bank,
        },
      }),
      ...(formData.pay_method === "cheque" && {
        payment_details: {
          cheque_no: formData.cheque_no,
        },
      }),
    };

    await Post("createInvoiceAndPrepaidTax", invoiceDataToSubmit)
      .then((response) => {
         handleToast({
        type:"SUCCESS",
        message:"Invoice submitted successfully!"
      })

        setReloadData(!reloadData);
        makeBlank();
      })
      .catch((error) => {
        setReloadData(!reloadData);
  
          handleToast({
        type:"ERROR",
        message:"An error occurred while submitting the invoice. Please check your network and try again"
      })
      });
  };

  const fetchData = async () => {
    try {
      const [dueDaysResponse, vendorResponse, bankResponse] = await Promise.all(
        [Get("dueDaysData"), Get("vendorDepartmentData"), Get("bank")]
      );

      setDueDays(dueDaysResponse);
      setVendors(vendorResponse?.results || []);
      setBanks(bankResponse?.results || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    // if (!hasAccess) return; 
    fetchData();
  }, [ reloadData]);

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  // Allow only digits (0-9) for cheque_no
  if (name === "cheque_no") {
    const numericRegex = /^[0-9]*$/;
    if (!numericRegex.test(value)) {
      return; // Ignore input if it's not numeric
    }
  }

  if (name === "vendor_department") {
    const selectedVendor = Array.isArray(vendors) ? vendors.find((vendor) => vendor.id === value) : null;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      vendor_department_name: selectedVendor ? selectedVendor.name : "",
      type: selectedVendor ? selectedVendor.type : "",
    }));
  } else if (name === "due_days") {
    const selectedDueDays = parseInt(value, 10);
    const today = new Date();
    const dueDate = new Date(today);
    dueDate.setDate(dueDate.getDate() + selectedDueDays);

    const formattedDueDate = dueDate.toISOString().split("T")[0];

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      due_date: formattedDueDate,
    }));
  } else {
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  }
};


  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;

    const newPayMethod =
      value === "credit_invoice"
        ? "credit_invoice"
        : value === "pay_later"
        ? "pay_later"
        : "";

    setFormData((prevData) => ({
      ...prevData,

      pay_method_status: value,
      pay_method: newPayMethod,
      due_date: null,
      note: "",
      bank: "",
      cheque_no: "",
    }));
  };

  const handleCancel = () => {
    makeBlank();
  };

  const fields = [
    {
      row: 1,
      column: "col-md-3",
      label: "Bill Date",
      type: "date",
      name: "date",
      placeholder: "Bill Date",
    },
    {
      row: 1,
      column: "col-md-3",
      label: "Vendor",
      type: "select-vendor",
      name: "vendor_department_name",
      placeholder: "Select Vendor",
      options: vendors,
    },
    {
      row: 1,
      column: "col-md-3",
      label: "Invoice Number",
      type: "invoice_no",
      name: "invoice_no",
      placeholder: formData.invoice_no || "Invoice Number",
    },
    {
      row: 2,
      column: "col-md-2",
      label: "Amount",
      name: "amount",
      type: "prefix-input",
      placeholder: "Amount",
    },
    {
      row: 2,
      column: "col-md-5",
      name: "pay_method_status",

      type: "radio",
      options: [
        { value: "pay_now", label: "Pay Now" },
        { value: "pay_later", label: "Pay Later" },
        { value: "credit_invoice", label: "Credit Invoice" },
      ],
    },
    {
      row: 4,
      column: "col-md-5",
      label: "Payment Method Options",
      type: "payment-method-options",
    },
    {
      row: 5,
      column: "col-md-5",
      label: "Payment Method Options",
      type: "pay-bank-options",
    },
    {
      row: 3,
      column: "col-md-3",
      label: "Due Days",
      type: "select-dueDays",
      name: "due_days",
      placeholder: "Select Due Days",
      options: dueDays,
    },

    ...(formData.pay_method_status !== "pay_now" ? [] : []),
    {
      row: 5,
      column: "col-md-12",
      label: "Do you want to add Prepaid Tax?",
      type: "checkbox",
      name: "prepaid_tax",
    },
  ];

  const paymentMethodOptions = [
    { value: "cash", label: "Cash" },
    { value: "bank", label: "Bank Card (ACH/EFT)" },
    { value: "cheque", label: "Cheque" },
  ];

  const groupedFields = fields.reduce((acc, field) => {
    const row = field.row;
    if (!acc[row]) {
      acc[row] = [];
    }
    acc[row].push(field);
    return acc;
  }, {});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    navigate(path);
  };

  const renderField = (field) => {
    if (field) {
      switch (field.type) {
        case "text":
          if (
            field.name === "note" &&
            (formData.pay_method === "cheque" || formData.pay_method === "bank")
          ) {
            return null;
          }
          return (
            <div className="form-group">
              <input
                type={field.type}
                className="form-control-borderless"
                name={field.name}
                placeholder={field.placeholder}
                value={formData[field.name]}
                onChange={handleChange}
              />
            </div>
          );
        case "invoice_no":
          return (
            <div
              className="form-group"
              style={{ position: "relative",  }}
            >
              <input
                type={field.type}
                className="form-control-invoice"
                name={field.name}
                placeholder=" "
                value={formData[field.name]}
                onChange={handleChange}
                maxLength={14}
              />
              <label htmlFor="invoice_no" className="floating-label-invoice">
                Invoice Number
              </label>
            </div>
          );

        case "date":
          return (
            <div className="form-group">
              {/* <input
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  borderRadius: "0px",
                  height: "52px",
                  marginBottom: "30px",
                }}
                type={field.type}
                className="form-control-borderless"
                name={field.name}
                placeholder={field.placeholder}
                value={formData[field.name] || today}
                onChange={handleChange}
              /> */}

              <CustomDateInput
                type={field.type}
                className="form-control-borderless"
                name={field.name}
                placeholder={field.placeholder}
                value={formData[field.name] || today}
                onChange={handleChange}
                 readOnly={true} 
                 showIcon={true}
                // inputStyle={{
          
                //     backgroundColor: "#ffffff",
                //     border: "none",
                //     borderBottom: "1px solid #ccc",
                //     borderRadius: "0px",
                //     height: "52px",

                //   }}
              />
            </div>
          );
        case "prefix-input":
          return (
            <div className="form-group col-md-12">
              <div
                className="form-group"
                style={{ position: "relative", marginTop: "10px" }}
              >
                <input
                  type="text"
                  className="form-control-invoice"
                  name={field.name}
                  placeholder=""
                  value={formData[field.name]}
                  onChange={handleChange}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                      .slice(0, 12);
                  }}
                />
                <label htmlFor="invoice_no" className="floating-label-invoice">
                  Amount
                </label>
              </div>
            </div>
          );

        case "select-vendor":
          return (
            <div className="form-group">
              <select
                className="input-select"
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  borderRadius: "0px",
                  height: "52px",
                  marginBottom: "30px",
                }}
                name="vendor_department"
                value={formData.vendor_department}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  if (selectedValue === "add-vendor") {
                    handleShow();
                    setFormData((prevData) => ({
                      ...prevData,
                      vendor_department: "",
                    }));
                  } else {
                    handleChange(e);
                  }
                }}
              >
                <option value="">Select Vendor</option>
                <option value="add-vendor">Add Vendor</option>

                {field.options && Array.isArray(field.options)
                  ? field.options
                      .filter((vendor) => !vendor.is_deleted)
                      .map((vendor) => (
                        <option key={vendor.id} value={vendor.id}>
                          {vendor.name}
                        </option>
                      ))
                  : ""}
              </select>
            </div>
          );

        case "select":
          return (
            <div className="form-group">
              <select
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  borderRadius: "0px",
                  height: "52px",
                  marginBottom: "30px",
                }}
                className="input-select"
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
              >
                <option value="">Select Bank</option>
                {banks.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {bank.name}
                  </option>
                ))}
              </select>
            </div>
          );
        case "select-dueDays":
          return (
            (formData.pay_method_status === "pay_later" ||
              formData.pay_method_status === "credit_invoice") && (
              <div className="form-group" style={{ position: "relative" }}>
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                    paddingRight: "24px",
                    marginBottom: "30px",
                  }}
                  required
                  className="form-control-borderless"
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                >
                  <option value="">{field.placeholder}</option>
                  {field.options && Array.isArray(field.options) && field.options.map((dueDays) => (
                    <option key={dueDays.id} value={dueDays.days}>
                      {dueDays.days}
                    </option>
                  ))}
                </select>

                <svg
                  width="16"
                  height="10"
                  viewBox="0 0 16 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                >
                  <g opacity="0.4" clipPath="url(#clip0_723_243)">
                    <path
                      d="M8.07608 9.20648C7.97615 9.20775 7.87708 9.18722 7.78523 9.14622C7.69338 9.10521 7.61078 9.04463 7.54275 8.96839L0.685603 1.82553C0.380841 1.50807 0.380841 1.016 0.685603 0.698544C0.990365 0.381084 1.46275 0.381084 1.76751 0.698544L8.09132 7.28585L14.3999 0.714417C14.7046 0.396957 15.177 0.396957 15.4818 0.714417C15.7866 1.03188 15.7866 1.52394 15.4818 1.8414L8.62465 8.98426C8.47227 9.14299 8.27417 9.22235 8.09132 9.22235L8.07608 9.20648Z"
                      fill="#000000"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_723_243">
                      <rect width="16" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )
          );

        case "radio":
          return (
            <div
              className=" d-flex align-items-center"
              style={{
                whiteSpace: "nowrap",
                border: "1px solid #ACB4AA",
                padding: "5px 5px",
                width: "fit-content",
                borderRadius: "40px",
                marginBottom: "20px",
              }}
            >
              <div className="d-flex">
                {field.options.map((option, index) => (
                  <div
                    key={index}
                    className="form-check"
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        formData[field.name] === option.value
                          ? "#4a5546"
                          : "transparent",
                      padding: "5px 25px",
                      borderRadius: "20px",
                    }}
                    onClick={() =>
                      handlePaymentMethodChange({
                        target: { name: field.name, value: option.value },
                      })
                    }
                  >
                    <label
                      className="form-check-label"
                      style={{
                        fontWeight: "normal",
                        color:
                          formData[field.name] === option.value
                            ? "#ffffff"
                            : "#282e26",
                      }}
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          );

        case "payment-method-options":
          return (
            formData.pay_method_status === "pay_now" && (
              <div
                className="d-flex align-items-center"
                style={{
                  whiteSpace: "nowrap",
                  border: "1px solid #ACB4AA",
                  padding: "5px 5px",
                  width: "fit-content",
                  borderRadius: "40px",
                  marginBottom: "30px",
                }}
              >
                {paymentMethodOptions.map((option, index) => (
                  <div
                    key={index}
                    className="form-check "
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        formData.pay_method === option.value
                          ? "#4a5546"
                          : "transparent",
                      padding: "5px 25px",
                      borderRadius: "20px",
                    }}
                    onClick={() =>
                      handleChange({
                        target: { name: "pay_method", value: option.value },
                      })
                    }
                  >
                    <label
                      className="form-check-label"
                      style={{
                        fontWeight: "normal",
                        color:
                          formData.pay_method === option.value
                            ? "#ffffff"
                            : "#282e26",
                      }}
                    >
                      {option.label}
                    </label>
                  </div>
                ))}
              </div>
            )
          );

        case "checkbox":
          return (
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                name={field.name}
                checked={formData[field.name]}
                onChange={handleChange}
              />
              <label className="form-check-label">{field.label}</label>
            </div>
          );

        case "pay-bank-options":
          return (
            (formData.pay_method === "cheque" ||
              formData.pay_method === "bank") && (
              <div className="row align-items-center">
                <div className="col-md-5 ">
                  <div className="form-group">
                    <select
                      required
                      style={{
                        backgroundColor: "#ffffff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                        marginBottom: "18px",
                      }}
                      className="input-select"
                      name="bank"
                      value={formData.bank}
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {formData.pay_method === "cheque" && (
                  <div className="col-md-5">
                    <div
                      className="form-group"
                      style={{ position: "relative", marginTop: "-12px" }}
                    >
                      <input
                        required
                        type="text"
                        className="form-control-invoice"
                        name="cheque_no"
                        placeholder=""
                        value={formData.cheque_no}
                        onChange={handleChange}
                        maxLength={20}
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                      <label
                        htmlFor="amount"
                        className="floating-label-invoice"
                      >
                        Cheque Number
                      </label>
                    </div>
                  </div>
                )}
              </div>
            )
          );

        default:
          return null;
      }
    } else {
      return null;
    }
  };

  return (
    <div className="">
      <ToastContainer />
      <div className="">
        <div
          className="responsive-box">
          <form onSubmit={handleSubmit}>
              <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", marginBottom: "20px" }}>
                 <h3 className="mb-1" style={{ margin: "0" }}>Add Invoice</h3>
              </div>
            {}
            {groupedFields
              ? Object.keys(groupedFields).map((rowKey) => (
                  <div
                    className="row"
                    style={{
                      gap: "10%",
                      paddingLeft: "5%",
                    }}
                    key={rowKey}
                  >
                    {groupedFields
                      ? groupedFields[rowKey].map((field, index) => (
                          <div key={index} className={field.column}>
                            {renderField(field)}
                          </div>
                        ))
                      : ""}
                  </div>
                ))
              : ""}

            {}
            {formData.prepaid_tax && (
              <div className="row mt-2">
                <div className="col-md-3 ml-3">
                  <div
                    className="form-group"
                    style={{
                      position: "relative",
                      marginTop: "18px",
                      marginLeft: "60px",
                    }}
                  >
                    <input
                      type="text"
                      className="form-control-invoice"
                      name="prepaid_amount"
                      id="prepaid_amount"
                      placeholder=""
                      value={formData.prepaid_amount}
                      onChange={handleChange}
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9.]/g, "")
                          .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                          .slice(0, 12);
                      }}
                    />
                    <label htmlFor="amount" className="floating-label-invoice">
                      Enter Prepaid Tax
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="">
              {}
              <div
                className="d-flex justify-content-end"
                style={{ gap: "15px" }}
              >
                <button
                  type="button"
                  className="btn btn-contained me-2"
                  onClick={handleCancel}
                  style={{
                    border: " 1px solid #282e26",
                    borderRadius: "20px",
                    width: "150px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  Clear
                </button>
                <button
                  type="submit"
                  className="btn"
                  style={{
                    color: "white",
                    backgroundColor: "#282e26",
                    borderRadius: "40px",
                    width: "150px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {}

      <div
        className="responsive-box">
        <TableComponent reloadData={reloadData} />
        <AddVendorModal
          show={showModal}
          handleClose={handleClose}
          onVendorAdded={handleVendorAdded}
        />
      </div>
    </div>
  );
}

export default AddInvoice;
